import brand from "./brand";

/* connectors */
const connectors = [
  { id: "mssql", name: "MS SQL", logo: brand.mssqlLogo },
  { id: "firestore", name: "Firestore", logo: brand.firestoreLogo },
  { id: "notion", name: "Notion", logo: brand.notionLogo },
  { id: "airtable", name: "Airtable", logo: brand.airtableLogo },
	{ id: "mongodb", name: "MongoDB", logo: brand.mongodbLogo, upcoming: true },
  { id: "postgresql", name: "PostgreSQL", logo: brand.postgresqlLogo, upcoming: true },
];
/**
 * 
 * @param {String} type 
 * @returns {Array || Null}
 */
const form = (type) => {
  const selection = {
    appKey: { id: "app-key", fieldName: "appKey", icon: "fts-icon-text", input: "inputMask", required: true },
    server: { id: "server", fieldName: "server", type: 0, required: true },
    user: { id: "user", fieldName: "user", type: 0, required: true },
    password: { id: "password", fieldName: "password", icon: "fts-icon-text", input: "inputMask", required: true },
    database: { id: "database", fieldName: "database", type: 0, required: true },
    project: { id: "project", fieldName: "project", type: 0, required: true },
    collection: { id: "collection", fieldName: "collection", type: 0, required: true },
    table: { id: "table", fieldName: "table", type: 0, required: true },
    base: { id: "base", fieldName: "base", type: 0, required: true },
  }
  switch(type) {
    case "mssql":
    case "postgresql":
      return [
        { ...selection.server },
        { ...selection.user },
        { ...selection.password },
        { ...selection.database },
        { ...selection.table }
      ];
    case "firestore":
      return [
        { ...selection.appKey },
        { ...selection.project },
        { ...selection.collection }
      ];
    case "notion":
      return [
        { ...selection.appKey },
        { ...selection.database }
      ];
    case "airtable":
      return [
        { ...selection.appKey },
        { ...selection.table },
        { ...selection.base }
      ];
  }
}

export default {
  connectors: connectors,
  form: form,
}